<ng-container
	*ngIf="['create', 'addCertification', 'addInterests', 'updateCertification','update', 'updateThumbnail', 'addAssessment', 'moderateCertification', 'inviteUser'].includes(action)">
	<app-form-view [popup]="'true'" [contentLoader]="loader" (helpTriggered)="helpTriggered = $event">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="people-form" fxLayout="column" fxLayoutAlign="start stretch">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch"
						fxLayoutGap="40px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text">
									{{info}}
								</p>
								<br />
								<p (click)="download()" *ngIf="sampleExcel" class="body-text hyperlink underline">
									{{this.locale.translate('download_sample_excel')}}</p>
							</div>



						</ng-container>
						<!-- <ng-container *ngIf="sampleExcel">
							<div class="form-info">
								<p (click)="download()">{{this.locale.translate('sample_excel')}}</p>

							</div>
						</ng-container> -->
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100"
								fxLayoutGap="20px" fxLayoutGap.xs="10px">
								<ng-container *ngIf="!(['moderateCertification', 'inviteUser'].includes(action))">
									<div fxLayout="column" fxLayoutAlign="center start"
										class="certification-form-container" fxLayoutGap="16px" fxLayoutGap.xs="15px">
										<ng-container *ngIf="action === 'addCertification'">
											<app-form-group [fieldList]="[titleField]" [config]="config"
												fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
												fxLayoutAlign.xs="start stretch" fxLayoutGap="10px" fxLayoutGap.xs="0px"
												(formObject)="formObjectReader($event)"
												(fieldIconEmit)="clearEmbed($event)">
											</app-form-group>
											<ng-container *ngIf="embedData">
												<!-- <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px">
													<span class="sub-caption-3">{{locale.translate('course_url')}}</span>
													<span class="body-text">{{embedData?.link}}</span>
												</div> -->
												<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="space-between stretch"
													fxLayoutGap="10px" fxLayout.xs="column"
													fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="5px"
													class="embed-view">
													<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="start start"
														fxLayoutGap="10px" fxLayout.xs="column"
														fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="5px">
														<ng-container *ngIf="embedData?.image">
															<div fxFlex="0 0 150px" fxFlex.xs="100%">
																<div class="thumbnail">
																	<img [src]="embedData?.image" alt="">
																</div>
															</div>
														</ng-container>
														<div fxLayout="column" fxLayoutAlign="start start"
															fxLayoutGap="10px">
															<ng-container *ngIf="embedData?.title">
																<a class="link-title linkable"
																	[attr.href]="embedData?.link" target="_blank">
																	{{embedData?.title}}
																</a>
															</ng-container>
															<ng-container *ngIf="embedData?.link">
																<a class="embed-url linkable"
																	[attr.href]="embedData?.link" target="_blank">
																	{{embedData?.link}}
																</a>
															</ng-container>
															<ng-container *ngIf="embedData?.description">
																<div class="embed-desc">{{embedData?.description}}</div>
															</ng-container>
														</div>
													</div>
													<div class="btn-holder"
														[ngClass]="{'fx-row fx-end-start' : !detectDevice?.resolutionState$?.value?.xs, 'xs' : detectDevice?.resolutionState$?.value?.xs}">
														<button class="remove-btn" mat-icon-button type="button"
															(click)="clearEmbed($event)">
															<mat-icon>clear</mat-icon>
														</button>
													</div>
												</div>
											</ng-container>
										</ng-container>
										<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
											fxLayoutAlign="start stretch" fxLayout.xs="column"
											fxLayoutAlign.xs="start stretch" fxLayoutGap="10px" fxLayoutGap.xs="0px"
											(formObject)="formObjectReader($event)">
										</app-form-group>
										<ng-container *ngIf="['create', 'update'].includes(action)">
											<div class="card-title" fxLayout="row" fxLayoutAlign="start center"
												fxLayoutGap="5px">
												<p class="hyperlink" (click)="addRole()">
													{{locale.translate('new_permission_group')}}</p>
											</div>
										</ng-container>
									</div>
								</ng-container>
								<ng-container *ngIf="action === 'inviteUser'">
									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="3px">
										<app-form-group [fieldList]="[functionalRole]" [formObjectData]="formObjectData"
											[config]="config" fxLayout="column" fxLayoutAlign="start stretch"
											fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap="10px"
											fxLayoutGap.xs="10px"
											(formObject)="formObjectReader($event)"></app-form-group>
										<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
											<p class="card-title hyperlink" (click)="manageFunctionalRoles()">
												{{locale.translate('manage_functional_roles')}}</p>
										</div>
										<app-form-group
											[fieldList]="[permissionGroup,department,location,city,emailID,description]"
											[config]="config" [formObjectData]="formObjectData" fxLayout="column"
											fxLayoutAlign="start stretch" (formObject)="formObjectReader($event)"
											fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap="10px"
											fxLayoutGap.xs="10px">
										</app-form-group>
									</div>
								</ng-container>
								<ng-container *ngIf="action === 'moderateCertification'">
									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<ng-container *ngIf="formFields?.length">
											<div class="block-title"> {{ locale.translate('who_are_you_reporting_to') }}
											</div>
										</ng-container>
										<div fxLayout fxLayoutAlign="center start" class="form-container">
											<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
												fxLayoutAlign="start stretch" fxLayout.xs="column"
												fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
												(formObject)="formObjectReader($event)">
											</app-form-group>
										</div>
									</div>
								</ng-container>
								<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px"
									fxLayoutGap.xs="10px">
									<app-alert id="people"></app-alert>
									<div class="btn-block" fxLayout="row" fxLayoutAlign="center center"
										fxLayoutGap="10px">
										<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button
											class="submit-btn" type="button">
											<ng-container
												*ngIf="['addCertification', 'addInterests', 'addAssessment'].includes(action)">
												{{locale.translate('save')}}
											</ng-container>
											<ng-container *ngIf="action === 'create'">
												{{locale.translate('create')}}
											</ng-container>

											<ng-container *ngIf="action === 'updateThumbnail'">
												{{locale.translate('upload')}}
											</ng-container>
											<ng-container *ngIf="action === 'moderateCertification'">
												{{locale.translate('ok')}}
											</ng-container>
											<ng-container
												*ngIf="action === 'updateCertification' || action === 'update'">
												{{locale.translate('update')}}
											</ng-container>
											<ng-container *ngIf="action === 'inviteUser'">
												{{locale.translate('invite')}}
											</ng-container>
										</button>
										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button
											class="cancel-btn" type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
		<insights>
			<app-help></app-help>
		</insights>
	</app-form-view>
</ng-container>

<ng-container *ngIf="['certificationDetail'].includes(action)">
	<ng-container *ngIf="!loader && data && data?.status?.key === 'moderation' && showCertificateModeration">
		<div class="register-learning-header-area">
			<div class="register-learning-header" fxLayout="column" fxLayoutAlign="start stretch">
				<div class="register-learning-view-info" fxLayout="row" fxLayoutAlign="start stretch"
					fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap="20px" fxLayoutGap.xs="10px">
					<div class="register-learning-process" fxFlex="1 1" fxLayout="row wrap"
						fxLayoutAlign="space-between center" fxLayoutGap="20px" fxLayoutGap.xs="10px">

						<div class="register-learning-view cursor-pointer"
							[ngClass]="{'user-view-xs' : detectDevice?.resolutionState$?.value?.xs}" fxLayout="row"
							fxLayoutAlign="start center" fxLayoutGap="10px">
							<div fxFlex="0 0 25px" class="user-thumbnail">
								<img [src]="currentUser?.profile?.profilePicURL"
									(error)="gfService.setErrorImage($event, 'man')" class="thumbnail">
							</div>
							<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="2px">
								<div fxFlex="1 1" class="currentUser-info entity-title">
									{{currentUser?.name}}
								</div>
								<div class="currentUser-info sub-caption-1">
									{{locale.translate('in_your_workgroup_reporting_to_you')}}
								</div>
							</div>
						</div>

						<!-- <div class="status-info">
									<ng-container *ngIf="assignmentDetail?.completedTime">
										<app-common-view
											[data]="{label: locale.translate('submitted_on'), value: assignmentDetail?.completedTime}">
										</app-common-view>
									</ng-container>
								</div> -->

						<div class="btn-containter" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
							<div>
								<button class="sub-action-btn" mat-stroked-button
									(click)="updateCertificationStatus('accept')">
									{{locale.translate('accept')}}</button>
							</div>
							<div>
								<button class="sub-action-btn" mat-stroked-button
									(click)="alertPopup('rejectCertification', null, {actionElement: rejectBtn})"
									#rejectBtn>
									{{locale.translate('reject')}}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<div class="register-form" fxLayout="column" fxLayoutAlign="start stretch">
		<app-form-view [popup]="'true'" [contentLoader]="loader" (helpTriggered)="helpTriggered = $event">
			<form-title>
				{{title}}
			</form-title>
			<content-area>
				<div class="register-learning-form" fxLayout="column" fxLayoutAlign="start stretch">
					<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text">
									{{info}}
								</p>
							</div>
						</ng-container>
						<div fxLayout="row" fxLayoutAlign="start center">
							<div class="register-learning-body" fxLayout="column" fxLayoutAlign="start stretch"
								fxLayoutGap="20px">
								<ng-container *ngIf="!loader && data">
									<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100"
										fxLayoutGap="20px">
										<app-common-view class="caption"
											[data]="{label: locale.translate('certification_name'), value: data?.title}">
										</app-common-view>
										<ng-container *ngIf="data?.URL">
											<app-common-view [data]="{label: locale.translate('url'), value: data?.URL}"
												(click)="embedLink(data?.URL)" class="cursor-pointer"></app-common-view>
										</ng-container>
										<app-common-view
											[data]="{label: locale.translate('issuing_authority'), value: data?.issuingAuthority?.name}">
										</app-common-view>
										<div class="learning-item" fxFlex="1 1">
											<div class="item-title skill-title">{{locale.translate('skills')}}</div>
											<div class="item-content">
												<ng-container *ngIf="!data?.skills?.length">
													<div fxLayout="column" fxLayoutAlign="center center"
														fxLayoutGap="15px">
														<p class="no-data">{{locale.translate('no_skills')}}</p>
													</div>
												</ng-container>
												<ng-container *ngIf="data?.skills?.length">
													<div class="comp-list" fxLayout="row wrap"
														fxLayoutAlign="start center" fxLayoutAlign.xs="start stretch"
														fxLayoutGap="10px">
														<ng-container *ngFor="let skill of data?.skills">
															<div class="comp-item" fxLayoutGap="10px">
																<app-chips type="progressive"
																	[data]="{title: skill?.skillName, progress:  skill?.skillLevel + '%', toolTip: true}">
																</app-chips>
															</div>
														</ng-container>
													</div>
												</ng-container>
											</div>
										</div>
										<div class="learning-item" fxLayout="column" fxLayoutAlign="start stretch"
											fxLayoutGap="10px">
											<div class="item-title">{{locale.translate('certificate')}}</div>
											<div class="item-content">
												<div class="certification" fxLayout="column"
													fxLayoutAlign="start stretch" fxLayoutGap="10px">
													<div fxLayout="row">
														<div fxFlex="0 0 194px" fxflex.xs="auto">
															<div class="thumbnail cursor-pointer"
																(click)="viewCertificate()">
																<img class="img" [src]="data?.thumbnail"
																	onError="this.src='assets/img/certificate.jpeg'"
																	alt="">
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
					</div>
					<!-- <div class="delete-btn" fxLayout="row" fxLayoutAlign="end start">
				<ng-container *ngIf="userID === currentUser?.userID && data">
					<button class="register-delete-btn" mat-icon-button #deleteCertification
						(click)="alertPopup('deleteCertification',data, {actionElement: deleteCertification})">
						<mat-icon svgIcon="delete"></mat-icon>
					</button>
				</ng-container>
			</div> -->
				</div>
			</content-area>
			<insights>
				<app-help></app-help>
			</insights>
		</app-form-view>
		<div class="delete-btn" fxLayout="row" fxLayoutAlign="end start">
			<ng-container *ngIf="userID === currentUser?.userID && data">
				<button class="register-delete-btn" mat-icon-button #deleteCertification
					(click)="alertPopup('deleteCertification',data, {actionElement: deleteCertification})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</ng-container>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="['endorsementDetail'].includes(action)">
	<app-content-view [contentLoader]="loader">
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<ng-container *ngIf="endorsementData?.length">
				<div class="card-list" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
					<ng-container
						*ngFor="let data of endorsementData;trackBy: gfService.trackByID.bind({'key': 'userID'})">
						<div class="card-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="7px">
							<div fxLayout="row" fxFlex="1 1" fxFlex.xs="auto" fxLayoutAlign="space-between stretch">
								<div class="user-info" fxLayout="column" fxLayoutAlign="start stretch"
									fxLayoutGap="0px">
									<app-chips type="prime" [data]="{title: data?.name, imageSrc: data?.profilePicURL}">
									</app-chips>
									<div class="user-details" fxLayout="row" fxLayoutAlign="start center"
										fxLayoutGap="10px">
										<div class="patch-small">{{data?.endorsement?.relationship?.caption}}</div>
										<span
											class="sub-caption-1 cursor-pointer">{{data?.endorsement?.createdAt}}</span>
									</div>
								</div>
								<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
									<app-chips type="progressive"
										[data]="{title: data?.endorsement?.skillName, progress: data?.endorsement?.skillLevel + '%', toolTip: true}">
									</app-chips>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
			</ng-container>
		</content-area>
	</app-content-view>
</ng-container>

<ng-container *ngIf="['workgroupProcess'].includes(action)">
	<app-content-view [contentLoader]="loader">
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<!-- <div class="card-list" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
				<div
					[innerHtml]="locale.translate('would_you_like_to_add_to_workgroup') | handleBar : {'name': userData?.name}">
				</div>
				<div class="primary-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="32px">
					<ng-container *ngIf="workgroupData?.length === 0 && !loader">
						<div class="no-data" fxLayout="row" fxLayoutAlign="center center">
							<p>
								{{locale.translate('do_not_have_workgroup_yet')}}
							</p>
						</div>
						<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
							<button mat-stroked-button class="submit-btn" type="button" #addWorkgroupActionEl
								(click)="addWorkgroup(addWorkgroupActionEl)">
								{{locale.translate('create_workgroup')}}
							</button>
						</div>
					</ng-container>
				</div>
				<ng-container *ngIf="workgroupData?.length">
					<div fxLayout="row">
						<div>
							<p class="linkable" (click)="addWorkgroup()">{{locale.translate('new_workgroup')}}</p>
						</div>
						<ng-container *ngFor="let data of workgroupData">
							<div fxFlex="0 1 700px" fxFlex.xs="auto">
								<div fxLayout="column" fxLayoutAlign="space-between center" class="main-content">
									<div class="sub-title" fxLayoutAlign="start start" fxFlex="1 1">
										{{ data?.groupName}}
									</div>
									<ng-container *ngIf="!data?.added">
										<div class="button-block" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
											fxFlex="0 0 auto">
											<div>
												<p class="linkable" (click)="addMemberToWorkgroup(data)">{{locale.translate('select')}}</p>
											</div>
										</div>
									</ng-container>
								</div>
							</div>
						</ng-container>
					</div>
				</ng-container>
			</div> -->

			<div class="moderation-form" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch"
						fxLayoutGap="20px">
						<div fxLayout="row" fxLayoutAlign="center center">
							<div class="add-wg-block" [ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}"
								fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100"
								fxLayoutGap="20px" fxLayoutGap.xs="10px">
								<div class="wg-suggestion-block" fxLayout="column" fxLayoutAlign="start stretch"
									fxLayoutGap="15px" fxLayoutGap.xs="10px">
									<div fxLayout="row" fxLayoutAlign="center center">
										<ng-container *ngIf="![null,undefined].includes(userData?.name)">
											<p class="caption"
												[innerHtml]="locale.translate('would_you_like_to_add_to_workgroup') | handleBar : {'name': userData?.name}">
											</p>
										</ng-container>
									</div>
									<ng-container *ngIf="workgroupData?.length === 0 && !loader">
										<div class="create-wg-block" fxLayout="column" fxLayoutAlign="center center"
											fxLayoutGap="15px" fxLayoutGap.xs="10px">
											<p class="wg-info">{{locale.translate('do_not_have_workgroup_yet')}}</p>
											<button mat-stroked-button class="add-btn" #addWorkgroupActionEl
												(click)="addWorkgroup(addWorkgroupActionEl)">
												{{locale.translate('create_workgroup')}}</button>
										</div>
									</ng-container>
								</div>
								<ng-container *ngIf="workgroupData?.length">
									<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
										<p class="add-link" (click)="addWorkgroup()">
											{{locale.translate('new_workgroup')}}</p>
									</div>
									<div class="wg-list" fxLayout="column" fxLayoutAlign="start stretch"
										fxLayoutGap="20px">
										<ng-container *ngFor="let data of workgroupData">
											<ng-container *ngIf="!data.added">
												<div class="wg-item" fxLayout="row" fxLayoutAlign="space-between center"
													fxLayout="8px">
													<div class="entity-title text-caps">
														{{ data?.groupName}}
													</div>
													<div>
														<p class="hyperlink" (click)="addMemberToWorkgroup(data)">
															{{locale.translate('select')}}</p>
													</div>
												</div>
											</ng-container>
										</ng-container>
									</div>
								</ng-container>
								<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
									<button mat-button class="cancel-btn"
										(click)="popupRef.close('cancel')">Cancel</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-content-view>
</ng-container>

<ng-container *ngIf="action === 'feedbacks'">
	<app-content-view [contentLoader]="loader">
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<ng-container *ngIf="feedbackData?.length">
				<div class="feedback-list" fxLayout="column" fxLayoutAlign="start stretch">
					<app-common-list [layout]="'column'" [layoutGap]="'15px'" [count]="totalRecordCount"
						(loadMoreData)="getFeedback($event)">
						<list-item class="feedback-list"
							*ngFor="let data of feedbackData; trackBy: gfService.trackByID.bind({'key': 'feedbackID'})">
							<content-area>
								<div class="feedback-item" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column"
									fxLayoutAlign="start stretch" fxLayoutGap="10px">
									<div class="user-info" fxLayout="row wrap" fxLayoutAlign="start center"
										fxLayoutGap="10px">
										<app-chips type="prime" (title)="userDetail(data?.feedbacker)"
											[data]="{imageSrc: data?.feedbacker?.profilePicURL, title: data?.feedbacker?.name}">
										</app-chips>
										<div class="patch-small">{{data?.feedbacker?.designation?.name}}</div>
										<span class="sub-caption-2 cursor-pointer">{{data?.date}}</span>
									</div>
									<div fxFlex="1 1">
										<ng-container *ngIf="![null,undefined].includes(data?.feedback)">
											<p class="short-txt" [innerHtml]="data?.feedback | nl2br"></p>
										</ng-container>
									</div>
								</div>
							</content-area>
						</list-item>
					</app-common-list>
				</div>
			</ng-container>
		</content-area>
	</app-content-view>
</ng-container>

<ng-container *ngIf="['endorsements'].includes(action)">
	<app-content-view>
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="endorsement-detail-listing" fxLayout="row" fxLayoutAlign="center center">
				<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="40px" fxLayout.xs="column"
					fxLayoutAlign.xs="start stretch" fxFlex="95" fxFlex.xs="100%">
					<ng-container *ngIf="!([null, undefined].includes(analyticsData?.skillMatch)) && !record">
						<div class="skill-item cursor-pointer" fxLayout="row" fxLayoutAlign="start stretch"
							fxLayoutGap="18px">
							<div class="thumbnail" fxFlex="0 0 50px">
								<app-pie-chart [chartData]="analyticsData?.pieChartData"
									[chartOptions]="analyticsData?.pieChartOptions">
								</app-pie-chart>
							</div>
							<div class="icon-item" fxFlex="1 0" fxLayout="column" fxLayoutAlign="center stretch">
								<span class="number-info">{{analyticsData?.skillMatch}}%</span>
								<span class="icon-title">{{locale.translate('skill_match')}}</span>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="info">
						<div class="form-info">
							<p class="body-text">
								{{info}}
							</p>
						</div>
					</ng-container>
					<ng-container *ngIf="record">
						<div class="skill-info" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
							<p class="block-title">
								<ng-container *ngIf="record?.actionFrom === 'skill'">
									{{locale.translate('skill')}}
								</ng-container>
								<ng-container *ngIf="record?.actionFrom !== 'skill'">
									{{locale.translate('competency')}}
								</ng-container>
							</p>
							<ng-container *ngIf="record?.actionFrom === 'skill'">
								<app-chips type="progressive" background="var(--secondary-four)"
									[data]="{title: record?.name, progress: record?.skillLevel + '%', expected: record?.expectedSkillLevel + '%', bufferColor: 'transparent', toolTip: true}">
								</app-chips>
							</ng-container>
							<ng-container *ngIf="record?.actionFrom !== 'skill'">
								<app-chips type="standard" background="var(--secondary-four)"
									[data]="{title: record?.name}">
								</app-chips>
							</ng-container>
						</div>
					</ng-container>
					<div fxLayout="column" fxLayoutAlign="start stretch">
						<mat-tab-group class="custom-tab"
							[ngClass]="{'responsive-tab': detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}"
							mat-align-tabs="center" [selectedIndex]="tabIndex" (selectedTabChange)="tabChange($event)"
							#tab>

							<ng-container *ngFor="let tab of tabArr">
								<mat-tab [label]="tab?.caption" [attr.data-key]="tab?.key">
									<ng-template matTabContent>
										<ng-container *ngIf="tab?.key === 'assessments' && tabKey === 'assessments'">
											<div class="assessment-container" fxLayout="column"
												fxLayoutAlign="start stretch" fxLayoutGap="12px">
												<ng-container
													*ngIf="(assessmentData?.length === 0 && !loader) || (currentUser?.userID !== userID)">
													<div class="primary-block" fxLayout="column"
														fxLayoutAlign="start stretch" fxLayoutGap="32px">
														<ng-container *ngIf="assessmentData?.length === 0 && !loader">
															<div class="no-data" fxLayout="row"
																fxLayoutAlign="center center">
																<p>
																	{{locale.translate('no_skill_assigned')}}
																</p>
															</div>
														</ng-container>
														<ng-container *ngIf="currentUser?.userID !== userID">
															<div class="btn-block" fxLayout="row"
																fxLayoutAlign="center center" fxLayoutGap="10px">
																<button mat-stroked-button class="submit-btn"
																	type="button" #addAssessmentActionEl
																	(click)="addAssessment(addAssessmentActionEl)">
																	{{locale.translate('add_assessment')}}
																</button>
															</div>
														</ng-container>
													</div>
												</ng-container>
												<div class="assessment-content-area" fxLayout="column"
													fxLayoutAlign="start stretch" fxLayoutGap="30px"
													[ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}">
													<loader [loader]="loader" [type]="'general'"></loader>
													<ng-container *ngIf="assessmentData?.length > 0 && !loader">
														<div fxLayoutGap.xs="10px" fxLayoutAlign="start start">
															<p class="no-data">
																{{locale.translate('skill_evaluated_through_an_assessment_outside_the_system')}}
															</p>
														</div>
													</ng-container>
													<ng-container *ngIf="assessmentData?.length">
														<div class="assessment-content-list" fxLayout="column"
															fxLayoutAlign="start stretch" fxLayoutGap="20px">
															<ng-container
																*ngFor="let data of assessmentData;trackBy: gfService.trackByID.bind({'key': 'userID'})">
																<div class="assessment-item" fxLayout="column"
																	fxLayoutAlign="start stretch" fxLayoutGap="18px">
																	<div fxLayout="column" fxLayoutAlign="start stretch"
																		fxLayoutGap="5px">
																		<p class="entity-title">{{data?.title}}
																		</p>
																		<p class="caption">{{data?.timeStamp}}
																		</p>
																	</div>
																	<ng-container
																		*ngIf="data?.skill?.length && [null,undefined].includes(record)">
																		<div class="assess-skill-item"
																			fxLayout="row wrap"
																			fxLayoutAlign="start stretch"
																			fxLayoutGap="10px">
																			<ng-container
																				*ngFor="let skill of data?.skill">
																				<app-chips *ngIf="skill?.skill?.key"
																					type="progressive"
																					[data]="{title: skill?.skill?.value, progress: skill?.skillLevel + '%', toolTip: true}">
																				</app-chips>
																			</ng-container>
																		</div>
																	</ng-container>
																	<ng-container
																		*ngIf="data?.skill?.length && ![null,undefined].includes(record)">
																		<div class="assess-skill-item"
																			fxLayout="row wrap"
																			fxLayoutAlign="start stretch"
																			fxLayoutGap="10px">
																			<ng-container
																				*ngFor="let skill of data?.skill">
																				<app-chips
																					*ngIf="skill?.skill?.key === record.ID"
																					type="progressive"
																					[data]="{title: skill?.skill?.value, progress: skill?.skillLevel + '%', toolTip: true}">
																				</app-chips>
																			</ng-container>
																		</div>
																	</ng-container>
																</div>
															</ng-container>
														</div>

													</ng-container>
												</div>
											</div>
										</ng-container>

										<ng-container *ngIf="tab?.key === 'managers' && tabKey === 'managers'">
											<ng-container [ngTemplateOutlet]="endorsementTemplate"
												[ngTemplateOutletContext]="{data: endorsementManagersData}">
											</ng-container>
										</ng-container>

										<ng-container *ngIf="tab?.key === 'peers' && tabKey === 'peers'">
											<ng-container [ngTemplateOutlet]="endorsementTemplate"
												[ngTemplateOutletContext]="{data: endorsementPeersData}">
											</ng-container>
										</ng-container>

										<ng-container
											*ngIf="tab?.key === 'certifications' && tabKey === 'certifications'">
											<div class="certificate-container" fxLayout="column"
												fxLayoutAlign="start stretch" fxLayoutGap="12px">

												<div class="primary-block" fxLayout="column"
													fxLayoutAlign="start stretch" fxLayoutGap="32px">
													<ng-container *ngIf="certificationData?.length === 0 && !loader">
														<div class="no-data" fxLayoutAlign="center center">
															<p>
																{{locale.translate('no_certificate_endorsement_yet')}}
															</p>
														</div>
													</ng-container>
													<ng-container *ngIf="userID === currentUser?.userID">
														<div class="btn-block" fxLayout="row"
															fxLayoutAlign="center center" fxLayoutGap="10px">
															<button mat-stroked-button class="submit-btn" type="button"
																#registerLearningActionEl
																(click)="registerLearning(registerLearningActionEl)">
																{{locale.translate('register_learning')}}
															</button>
														</div>
													</ng-container>
												</div>
												<div class="certificate-content-area" fxLayout="column"
													fxLayoutAlign="start stretch" fxLayoutGap="30px"
													[ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}">
													<loader [loader]="loader" [type]="'general'"></loader>

													<ng-container *ngIf="certificationData?.length">

														<div class="certificate-content-list" fxLayout="column"
															fxLayoutAlign="start stretch" fxLayoutGap="30px"
															fxLayoutGap.xs="15px">
															<ng-container
																*ngFor="let data of certificationData; let i = index">
																<div class="certificate-item" fxLayout="column"
																	fxLayoutAlign="start start" fxLayoutGap="6px">
																	<div fxLayout="row" fxFlex="1 1"
																		fxLayoutAlign="start start" fxLayoutGap="20px">
																		<ng-container
																			*ngIf="![null, undefined].includes(data?.thumbnail)">
																			<div fxFlex="0 0 100px">
																				<div class="thumbnail">
																					<img [src]="data?.thumbnail"
																						(error)="gfService.setErrorImage($event, 'broken_image')"
																						alt=""
																						(click)="certificationDetail(data)">
																				</div>
																			</div>
																		</ng-container>
																		<div class="short-info" fxFlex="1 1"
																			fxLayout="column"
																			fxLayoutAlign="space-between start"
																			fxLayoutGap="5px">
																			<p class="certificate-title cursor-pointer"
																				(click)="certificationDetail(data)">
																				{{data?.title}}</p>
																			<div class="sub-caption-1" fxLayout="row"
																				fxLayoutGap="8px">
																				<!-- <span>{{data?.issuingAuthority}}</span> -->
																				<span>{{data?.issuingAuthority?.name}}</span>
																			</div>
																			<ng-container
																				*ngIf="data?.skills?.length && detectDevice?.resolutionState$?.value?.deviceType !== 'mobile'">
																				<ng-container
																					*ngFor="let skill of data?.skills;trackBy: gfService.trackByID.bind({'key': 'skill'})">
																					<app-chips type="progressive"
																						background="var(--secondary-four)"
																						[data]="{title: skill?.skillName, progress: skill?.skillLevel + '%', bufferColor: 'transparent', toolTip: true}">
																					</app-chips>
																				</ng-container>
																			</ng-container>
																		</div>
																	</div>
																	<ng-container
																		*ngIf="data?.skills?.length && detectDevice?.resolutionState$?.value?.deviceType === 'mobile'">
																		<ng-container
																			*ngFor="let skill of data?.skills;trackBy: gfService.trackByID.bind({'key': 'skill'})">
																			<app-chips type="progressive"
																				background="var(--secondary-four)"
																				[data]="{title: skill?.skillName, progress: skill?.skillLevel + '%', bufferColor: 'transparent', toolTip: true}">
																			</app-chips>
																		</ng-container>
																	</ng-container>
																</div>
															</ng-container>
														</div>
													</ng-container>
												</div>
											</div>
										</ng-container>

										<ng-container *ngIf="tab?.key === 'sharing' && tabKey === 'sharing'">
											<div class="share-container" fxLayout="column" fxLayoutAlign="start stretch"
												fxLayoutGap="12px">
												<div class="primary-block" fxLayout="column"
													fxLayoutAlign="start stretch" fxLayoutGap="32px">
													<ng-container *ngIf="sharingData?.length === 0 && !loader">
														<div class="no-data" fxLayoutAlign="center center">
															<p>
																{{locale.translate('no_sharing_resources')}}
															</p>
														</div>
													</ng-container>
													<div class="btn-block" fxLayout="row" fxLayoutAlign="center center"
														fxLayoutGap="15px" fxLayout.xs="column">
														<button mat-stroked-button class="submit-btn" type="button"
															#shareKnowledgeBeadActionEl
															(click)="shareKnowledgeBead(shareKnowledgeBeadActionEl)">
															{{locale.translate('share_knowledge_bead')}}
														</button>
														<!-- <button mat-stroked-button class="submit-btn" type="button" #answerQuestionActionEl
															(click)="answerQuestion(answerQuestionActionEl)">
															{{locale.translate('answer_questions')}}
														</button> -->
													</div>
												</div>
												<div class="share-content-area" fxLayout="column"
													fxLayoutAlign="start stretch" fxLayoutGap="30px"
													[ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}">
													<loader [loader]="loader" [type]="'general'"></loader>
													<ng-container *ngIf="sharingData?.length">
														<div class="share-content-list" fxLayout="column"
															fxLayoutAlign="start stretch" fxLayoutGap="30px"
															fxLayoutGap.xs="15px">
															<ng-container
																*ngFor="let data of sharingData; trackBy: gfService.trackByID.bind({'key': 'resourceID'})">
																<div class="share-item" fxLayout="column"
																	fxLayoutAlign="start stretch" fxLayoutGap="6px">
																	<div fxLayout="row" fxLayoutAlign="start start"
																		fxLayoutGap="14px">
																		<ng-container *ngIf="data?.thumbnail">
																			<div [fxFlex]="(detectDevice?.resolutionState$?.value?.deviceType === 'mobile') ? '0 0 90px' : '0 0 140px'"
																				class="thumbnail-block">
																				<div class="thumbnail cursor-pointer"
																					(click)="navigateToResource(data)">
																					<img class="img"
																						[src]="data?.thumbnail"
																						(error)="gfService.setErrorImage($event, 'broken_image')">
																				</div>
																			</div>
																		</ng-container>
																		<div class="search-card-content" fxFlex="1 1"
																			fxFlex.xs="auto" fxLayout="column"
																			fxLayoutAlign="start stretch"
																			fxLayoutGap="4px">
																			<div fxLayout="row"
																				fxLayoutAlign="start start">
																				<div class="sub-txt-patch">
																					{{data?.resourceTypeID?.caption}}
																				</div>
																			</div>
																			<div fxLayout="row" fxFlex="1 1"
																				fxLayoutAlign="start center"
																				fxLayoutGap="5px">
																				<p class="card-title linkable"
																					(click)="navigateToResource(data)">
																					{{data?.title}}</p>
																			</div>

																			<!---only for desktop-->
																			<div fxLayout="row"
																				fxLayoutAlign="start center"
																				fxLayoutGap="5px">
																				<ng-container
																					*ngIf="!([null, undefined, ''].includes(data.createdTimeStamp))">
																					<p class="sub-caption-2">
																						{{data?.createdTimeStamp}}
																					</p>
																				</ng-container>
																				<ng-container
																					*ngIf="data?.skills?.length && detectDevice?.resolutionState$?.value?.deviceType !== 'mobile'"
																					[ngTemplateOutlet]="shareSkillTemplate"
																					[ngTemplateOutletContext]="{data: data?.skills}">
																				</ng-container>
																			</div>
																			<!--end-->
																		</div>
																	</div>
																	<!--only for mobile-->
																	<ng-container
																		*ngIf="data?.skills?.length && detectDevice?.resolutionState$?.value?.deviceType === 'mobile'"
																		[ngTemplateOutlet]="shareSkillTemplate"
																		[ngTemplateOutletContext]="{data: data?.skills}">
																	</ng-container>
																	<!--end-->
																</div>

															</ng-container>
														</div>

													</ng-container>
												</div>
											</div>
										</ng-container>

									</ng-template>
								</mat-tab>
							</ng-container>

						</mat-tab-group>
					</div>
				</div>
			</div>
		</content-area>
	</app-content-view>
</ng-container>

<ng-container *ngIf="action === 'updateCompetencySKillLevel'">
	<app-content-view [contentLoader]="loader">
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="competency-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
				<ng-container
					*ngIf="!popupRef?.componentInstance?.popupLoader && !competencyData?.competencies?.length && !competencyData?.otherSkills?.length">
					<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
						<p class="no-data">{{locale.translate('no_competency_added')}}</p>
					</div>
				</ng-container>
				<ng-container *ngIf="competencyData?.competencies?.length">

					<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
						<div class="prof-content-title" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
							<mat-icon class="common-icon" svgIcon="role"></mat-icon>
							<span class="entity-title">{{competencyData?.roleName}}</span>
						</div>
						<div class="competency-list" fxFlex="1 1 auto" fxLayout="row wrap" fxLayoutAlign="start stretch"
							fxLayoutGap="15px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch">
							<ng-container
								*ngFor="let competency of competencyData?.competencies;trackBy: gfService.trackByID.bind({'key': 'ID'})">

								<div class="competency-item" fxFlex="0 0 357px" fxFlex.xs="1 1 auto" fxLayoutGap="10px"
									fxLayout.xs="column" fxLayoutAlign.xs="start stretch">
									<app-collapsible-block class="collapsible-block"
										[data]="{svgIcon:'shield',title: competency?.name}"
										[toggle]="{expanded: false, showToggle: true, closedIcon: 'expand_less', expandedIcon: 'expand_more'}"
										radius="5px" color="transparent" borderColor="var(--secondary-three)"
										(opened)="getEndorsementCertifyCount($event, competency)">
										<div header-insight class="comp-header">
											<div fxLayout="row" fxLayoutAlign="start center"
												fxLayoutAlign.xs="space-between stretch" fxLayoutGap="10px"
												fxFlex="1 0">
												<div fxLayoutAlign="center center" fxFlex="1 1 80px">
													<mat-progress-bar class="prog-br" color="primary" mode="determinate"
														[value]="competency?.avg">
													</mat-progress-bar>
												</div>
											</div>
										</div>
										<div class="sub-content-area" fxLayout="column" fxLayoutAlign="start stretch"
											fxLayoutGap="20px" fxLayoutAlign.xs="start stretch">
											<loader [loader]="competency?.loader" [type]="'general'"></loader>
											<ng-container *ngIf="competency?.skills?.length">
												<div fxLayout="row wrap" fxLayoutAlign="start center"
													fxLayoutGap="10px">
													<ng-container *ngFor="let skill of competency?.skills">
														<app-weightage class="weightage" [field]="skill?.field"
															[formControl]="skill?.control" [control]="skill?.control">
														</app-weightage>
													</ng-container>
												</div>
											</ng-container>
											<div class="com-footer-area" fxFlex="1 1 auto" fxLayout="row"
												fxLayoutAlign="center stretch" fxLayoutGap="15px">
												<app-badge class="comp-icon"
													(click)="endorsementsForCompetency(0,competency,{count: (competency?.peersCount + competency?.managersCount)})"
													[ngClass]="{'cursor-pointer' : (competency?.peersCount + competency?.managersCount)}"
													[count]="(competency?.peersCount + competency?.managersCount) || 0"
													svgIcon="like" size="16px"></app-badge>
												<app-badge class="comp-icon"
													(click)="endorsementsForCompetency(2,competency,{count: competency?.certificationsCount})"
													[ngClass]="{'cursor-pointer' : competency?.certificationsCount}"
													[count]="competency?.certificationsCount || 0" svgIcon="star-badge"
													size="16px"></app-badge>
												<app-badge class="comp-icon"
													(click)="endorsementsForCompetency(3,competency,{count: competency?.sharingCount})"
													[ngClass]="{'cursor-pointer' : competency?.sharingCount}"
													[count]="competency?.sharingCount || 0" svgIcon="contribution"
													size="16px"></app-badge>
											</div>
										</div>
									</app-collapsible-block>
								</div>

							</ng-container>
						</div>
					</div>

				</ng-container>
				<ng-container *ngIf="competencyData?.otherSkills?.length">
					<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
						<div class="prof-content-title" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
							<mat-icon class="common-icon" svgIcon="skill"></mat-icon>
							<span class="entity-title">{{locale.translate('other_skills')}}</span>
						</div>
						<div class="competency-list" fxFlex="1 1 auto" fxLayout="row wrap" fxLayoutAlign="start stretch"
							fxLayoutGap="15px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch">
							<div class="sub-content-area" fxLayout="column" fxLayoutAlign="start stretch"
								fxLayoutGap="20px" fxLayoutAlign.xs="start stretch">
								<div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
									<ng-container
										*ngFor="let skill of competencyData?.otherSkills;trackBy: gfService.trackByID.bind({'key': 'ID'})">
										<app-weightage class="weightage" [field]="skill?.field"
											[formControl]="skill?.control" [control]="skill?.control">
										</app-weightage>
									</ng-container>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</content-area>
	</app-content-view>
</ng-container>

<ng-container *ngIf="['userFilter'].includes(action)">
	<app-content-view [contentLoader]="loader">
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="user-filter" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
					<div class="filter-list">
						<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="7px">
							<ng-container *ngFor="let filterData of data?.options; let i = index;">
								<div class="filter-list-item" fxLayout="row" fxLayoutAlign="space-between start"
									fxLayout="8px">
									<div class="filter-list-title linkable" (click)="getDetail({index: i})"
										[ngClass]="{'active': (filterData?.value === data?.param?.value)}">
										{{ filterData?.value }}
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-content-view>
</ng-container>

<ng-template #endorsementTemplate let-data="data">
	<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px">
		<loader [loader]="loader" [type]="'general'"></loader>
		<div class="endorsement-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="12px">
			<ng-container *ngIf="data?.length === 0 && !loader">
				<div class="primary-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="32px">
					<ng-container *ngIf="data?.length === 0 && !loader">
						<div class="no-data" fxLayoutAlign="center center">
							<p>
								{{(tabKey === 'managers') ? locale.translate('no_managers_endorsement_yet') :
								locale.translate('no_peer_endorsement_yet')}}
							</p>
						</div>
					</ng-container>

					<!-- <ng-container *ngIf="tabKey !== 'peers'">
						<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
							<button mat-stroked-button class="submit-btn" type="button" (click)="requestEndorsement()">
								{{locale.translate('request_endorsement')}}
							</button>
						</div>
					</ng-container> -->
				</div>
			</ng-container>
			<div class="endorsement-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px"
				[ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}">
				<loader [loader]="loader" [type]="'general'"></loader>
				<ng-container *ngIf="data?.length > 0 && !loader">
					<div fxLayoutGap.xs="10px" fxLayoutAlign="start start">
						<p class="no-data">
							{{(tabKey === 'managers') ? locale.translate('manager_endorsement') :
							locale.translate('peer_endorsement')}}
						</p>
					</div>
				</ng-container>
				<ng-container *ngIf="data?.length">
					<div class="endorse-card-list" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="18px"
						fxLayoutGap.xs="10px">
						<ng-container
							*ngFor="let endorsementData of data;trackBy: gfService.trackByID.bind({'key': 'userID'})">
							<div class="endorse-card-item" fxLayout="column" fxLayoutAlign="start stretch"
								fxLayoutGap="7px">
								<div fxLayout="row" fxFlex="1 1" fxFlex.xs="auto" fxLayoutAlign="start center">
									<div class="user-info" fxLayout="column" fxLayoutAlign="start stretch"
										fxLayoutGap="0px">
										<div fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign="5px">
											<app-chips type="prime" classes="capitalize"
												[data]="{title: endorsementData?.name, imageSrc: endorsementData?.profilePicURL}">
											</app-chips>
											<p class="date cursor-pointer">{{endorsementData?.endorsement?.createdAt}}
											</p>
										</div>
										<div class="user-details" fxLayout="row wrap" fxLayoutAlign="start center"
											fxLayoutGap="10px">
											<div class="course-duration sub-txt-patch">
												{{endorsementData?.endorsement?.relationship?.caption}}
											</div>
											<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
												<app-chips type="progressive"
													[data]="{title: endorsementData?.endorsement?.skillName, progress: endorsementData?.endorsement?.skillLevel + '%', toolTip: endorsementData?.endorsement?.showTooltip}">
												</app-chips>
											</div>
										</div>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #shareSkillTemplate let-data="data">
	<div class="share-skill-item" fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="10px">
		<ng-container *ngFor="let skill of data">
			<app-chips type="progressive"
				[data]="{title: skill?.skill?.value, progress:  skill?.skillLevel + '%', toolTip: true}">
			</app-chips>
		</ng-container>
	</div>
</ng-template>

<ng-container *ngIf="action === 'assignSkill'">
	<app-content-view [contentLoader]="loader">
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="competency-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
				<ng-container
					*ngIf="!popupRef?.componentInstance?.popupLoader && !competencyData?.competencies?.length && !competencyData?.otherSkills?.length">
					<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
						<p class="no-data">{{locale.translate('no_competency_added')}}</p>
					</div>
				</ng-container>
				<ng-container *ngIf="competencyData?.competencies?.length">
					<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
						<div class="prof-content-title" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
							<mat-icon class="common-icon" svgIcon="role"></mat-icon>
							<span class="entity-title">{{competencyData?.roleName}}</span>
						</div>
						<div class="competency-list" fxFlex="1 1 auto" fxLayout="row wrap" fxLayoutAlign="start stretch"
							fxLayoutGap="15px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch">
							<ng-container
								*ngFor="let competency of competencyData?.competencies;trackBy: gfService.trackByID.bind({'key': 'ID'})">

								<div class="competency-item" fxFlex="0 0 357px" fxFlex.xs="1 1 auto" fxLayoutGap="10px"
									fxLayout.xs="column" fxLayoutAlign.xs="start stretch">
									<app-collapsible-block class="collapsible-block"
										[data]="{svgIcon:'shield',title: competency?.name}"
										[toggle]="{expanded: false, showToggle: true, closedIcon: 'expand_less', expandedIcon: 'expand_more'}"
										radius="5px" color="transparent" borderColor="var(--secondary-three)"
										(opened)="getEndorsementCertifyCount($event, competency)">
										<div class="sub-content-area" fxLayout="column" fxLayoutAlign="start stretch"
											fxLayoutGap="20px" fxLayoutAlign.xs="start stretch">
											<loader [loader]="competency?.loader" [type]="'general'"></loader>
											<ng-container *ngIf="competency?.skills?.length">
												<div fxLayout="row wrap" fxLayoutAlign="start center"
													fxLayoutGap="10px">
													<ng-container *ngFor="let skill of competency?.skills">
														<app-weightage class="weightage" [field]="skill?.field"
															[formControl]="skill?.control" [control]="skill?.control">
														</app-weightage>
													</ng-container>
												</div>
											</ng-container>
										</div>
									</app-collapsible-block>
								</div>

							</ng-container>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="competencyData?.otherSkills?.length">
					<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
						<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
							<div class="prof-content-title" fxLayout="row" fxLayoutAlign="start center"
								fxLayoutGap="10px">
								<mat-icon class="common-icon" svgIcon="skill"></mat-icon>
								<span class="entity-title">{{locale.translate('other_skills')}}</span>
							</div>
							<div class="">
								<p class="hyperlink">
									{{locale.translate('add_skill')}}</p>
							</div>
						</div>

						<div class="competency-list" fxFlex="1 1 auto" fxLayout="row wrap" fxLayoutAlign="start stretch"
							fxLayoutGap="15px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch">
							<div class="sub-content-area" fxLayout="column" fxLayoutAlign="start stretch"
								fxLayoutGap="20px" fxLayoutAlign.xs="start stretch">
								<div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
									<ng-container
										*ngFor="let skill of competencyData?.otherSkills;trackBy: gfService.trackByID.bind({'key': 'ID'})">
										<app-weightage class="weightage" [field]="skill?.field"
											[formControl]="skill?.control" [control]="skill?.control">
										</app-weightage>
									</ng-container>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
				<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px" fxLayoutGap.xs="10px">
					<app-alert id="people"></app-alert>
					<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
						<button (click)="submit()" mat-stroked-button class="submit-btn" type="button">
							{{locale.translate('assign')}}
						</button>
						<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button
							class="cancel-btn" type="button">{{locale.translate('cancel')}}</button>
					</div>
				</div>
			</div>
		</content-area>
	</app-content-view>
</ng-container>